// EP-160 (section 2.7, D5): where the sign-up box and the owner's terms banner
// send people to read FlowRent's terms and privacy policy.
//
// flowrent.io has no /terms page yet, so the terms link points at the
// product-wide privacy policy (the page the login footer links to, EP-126)
// until the terms are published. Change TERMS_URL here once they are; every
// link reads it.
export const PRIVACY_POLICY_URL = 'https://flowrent.io/privacy-policy'
export const TERMS_URL = PRIVACY_POLICY_URL
